import { COUNTRY_CONFIG } from '@global/App/constants/location/configs';
import { LOCALES_CONFIG } from '@global/App/constants/location/constants';
import { SiteConfig } from '@src/global/utils/SiteConfig';

export const prefixPath = (path: string, prefix: string) => {
  return SiteConfig.isNonLocalizedSite() ? path : `/${prefix}${path}`;
};

export const localizeRoutes = (
  routes: {
    path: string;
    component?: React.FC<{ isLogged: boolean }>;
    localize?: boolean;
  }[]
) => {
  return routes.map((route) => {
    if (route.localize !== false) {
      return {
        ...route,
        path: prefixPath(route.path, ':locale'),
      };
    }
    return { ...route };
  });
};

/**
 * Checks if supported language already exists in path.
 * If it does return true, else false
 */
export const langExistsInPath = (
  supportedLngs: { code: string; lang: string }[]
) => {
  const currentLang = window.location.pathname
    .split('/')
    .filter((v) => v.length)
    .shift();
  return supportedLngs.map((lang) => lang.code).indexOf(currentLang) !== -1;
};

export const getCurrentPath = () => {
  return window.location.pathname + window.location.search;
};

export const matchCurrentLocation = (matchTo: string) => {
  if (`/${location.pathname.split('/')[2]}` === matchTo) return true;
  return false;
};

export const getLocaleConfig = (country = ''): COUNTRY_CONFIG => {
  const locale = `en-${country.toLowerCase()}`;
  return LOCALES_CONFIG[locale] || {};
};
